module.exports = __webpack_public_path__ + "static/4bagr-icon-a0dd735ae1d3eabec27957c2a0a2e1f9.png";